/**  
 * created by panjm on 2019-10-25
 * 
 * description： 审批设置相关接口地址配置
 * 
 */

const config = require('libs/config.js');

const setting = {
	// 表格数据接口地址
	getList: config.MS_SP_PATH + '/v1/spGroupMg/spGroups',
	// 停用启用接口地址
	updateStatus: config.MS_SP_PATH + '/v1/spGroupMg/spGroups/changeStatus',
	// 关系图
	getRelation: config.MS_SP_PATH + '/v1/spGroupMg/spGroups/relation',
	// 删除审批流
	del: pkid => config.MS_SP_PATH + `/v1/spGroupMg/spGroup/${pkid}`,
	// 新增审批流
	add: config.MS_SP_PATH + '/v1/spGroupMg/spGroup',
	// 修改审批流
	update: pkid => config.MS_SP_PATH + `/v1/spGroupMg/spGroup/${pkid}`,
	// 子节点表格数据接口地址
	getNodeList: pkid => config.MS_SP_PATH + `/v1/spNodeMg/spNodes/${pkid}`,
	// 添加子节点
	addNode: config.MS_SP_PATH + '/v1/spNodeMg/spNode',
	// 修改子节点
	updateNode: pkid => config.MS_SP_PATH + `/v1/spNodeMg/spNode/${pkid}`,
	// 删除子节点
	delNode: pkid => config.MS_SP_PATH + `/v1/spNodeMg/spNode/${pkid}`,
	// 审批部门列表【get】
	getUserdpname: config.API_MB + '/mbdep/all',
	// 审批部门人列表【get】
	getDpuser: config.API_MB + '/mbopt/dep/list'
};

export default setting;



// WEBPACK FOOTER //
// ./src/api/setting/index.js